export default class CreateAppDialogController {
    /** @ngInject */
    constructor(DialogService, apps, DeveloperApi, ToastService, Loader, ErrorsService) {
        this.DialogService = DialogService;
        this.apps = apps;
        this.DeveloperApi = DeveloperApi;
        this.ToastService = ToastService;
        this.Loader = Loader;
        this.ErrorsService = ErrorsService;
        this.onInit();
    }

    onInit() {
        this.genericErrors = this.ErrorsService.getGenericErrors();
        this.app = {
            name: null
        };
    }

    createApp() {
        if (!this.app.name.length) return;

        this.Loader.show();

        this.DeveloperApi.create(this.app)
            .then((data) => {
                this.apps.push(data);

                this.app.name = '';
                this.Loader.hide();
                this.ToastService.show(this.ToastService.createSimple({
                    text: 'App created',
                    position: 'bottom right'
                }));
                this.cancel();
            });
    }

    cancel() {
        this.DialogService.cancel();
    }
}



// WEBPACK FOOTER //
// ./app/components/developer-settings/api-access/dialog/create-app/create-app.controller.js